import { create } from 'zustand';

/**
 * The shop session based on the MMA ServiceAPI.
 * See: https://igusdev.atlassian.net/wiki/spaces/KIIGUS/pages/33259528/ServiceApi+Doku+MMA
 */
export interface Session {
  sessionId: string;
  server: string;
  priceCountry: string;
  currency: string;
  decimalPlaces: number;
  country: string;
  language: string;
  customerId: number;
  cartArticleCount: number;
  userCountry: string;
  userCultures?: string[];
}

export interface SessionStore {
  setSession: (session?: Session) => void;
  session?: Session;
}

export const useSessionStore = create<SessionStore>(set => ({
  session: undefined,
  setSession: session => {
    set(() => ({ session }));
  },
}));
